/** Minimum Agent version for scene/automation sync_full + hidden entity support. */
export const MIN_AGENT_VERSION_LINKAGE = "0.2.18";

/**
 * Config Flow OAuth (Xiaomi HTML auth_url cache + progress merge).
 * Below this, remote vendor OAuth is unreliable from SaaS.
 */
export const MIN_AGENT_VERSION_INTEGRATION_OAUTH = "0.5.5";

/**
 * Options abort channel, discovery ignore_flow, flow_cleanup.
 */
export const MIN_AGENT_VERSION_INTEGRATION_FLOW = "0.5.6";

export function parseAgentVersion(raw: string): number[] | null {
  const v = raw.trim().replace(/^v/i, "");
  if (!v || v === "—" || v === "待同步") return null;
  const parts = v.split(".").map((p) => parseInt(p, 10));
  if (parts.some((n) => Number.isNaN(n))) return null;
  return parts;
}

export function compareAgentVersion(a: string, b: string): number {
  const pa = parseAgentVersion(a);
  const pb = parseAgentVersion(b);
  if (!pa && !pb) return 0;
  if (!pa) return -1;
  if (!pb) return 1;
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff;
  }
  return 0;
}

export function agentNeedsLinkageUpgrade(agent: string): boolean {
  if (!parseAgentVersion(agent)) return false;
  return compareAgentVersion(agent, MIN_AGENT_VERSION_LINKAGE) < 0;
}

export function agentNeedsIntegrationOauthUpgrade(agent: string): boolean {
  if (!parseAgentVersion(agent)) return false;
  return compareAgentVersion(agent, MIN_AGENT_VERSION_INTEGRATION_OAUTH) < 0;
}

export function agentVersionUnknown(agent: string): boolean {
  return !parseAgentVersion(agent);
}
